import API from '../API/API'
import moment from 'moment'
import Utils from '@/Utils/Utils'

const FeedStore = {
  api: API,
  utils:Utils,
  state: {
    currentUserId: 0,
    serviceId: 0,
    listings: [],
    fields: [],
    service: {},
    sortedField: '',
    sortedDirection: 'DESC',
    searchForm: [],
    filterListings:false,
    filteredListings:[],
    showSearch:false,
    citySearchForm: {
      name: 'city',
      value: '',
      type: "text"
    },
    stateSearchForm: {
      name: 'state',
      value: '',
      type: "text"
    },
    serviceSlug:'',
    type:'Active',
    mode:'Card'
  },
  getListings: function(success,error,maintenance){
    let self = this;
    this.api
    .getFeed(this.state.serviceId,this.state.currentUserId,this.state.type)
    .then(function (res) {
      if (res.data) {
        let data = res.data
        if (data.error) {
          error(data.error)
        } else {
            if(data.maintenanceMode){
              maintenance()
            }else{
              self.state.listings = data.listings.sort((a,b) => {
                
                let aDateField = a.fields.find(field => {
                  return field.name == "Date Of Competition"
                });

                let bDateField = b.fields.find(field => {
                  return field.name == "Date Of Competition"
                });

                if(aDateField && bDateField) {
                  return self.sortDateDesc(moment(aDateField.value ), moment(bDateField.value));

                }

                return true
              })
              self.state.listings.map(it => {
                it.showInfo = false
                let website = it.fields.find(field => {
                  return field.type == 'Website';
                });
                if(website) {
                  it.website = website.value
                }
              });
              success(self.state.fields)
            }
        }
      }else{
          error("Failed to get listings");
      }
    })
    .catch(e => {
      console.log(e)
      error('An Error Occurred')
    })
  },
  getServiceBySlug: function(success,error,maintenance) {
    let self = this;
    this.api
    .getServiceBySlug(this.state.serviceSlug)
    .then(function (res) {
      if (res.data) {
        let data = res.data
        if (data.error) {
          error(data.error)
        } else {
            if(data.maintenanceMode){
              maintenance()
            }else{
              self.state.serviceId = data.service.id
              success()
            }
        }
      }else{
          error("Failed to get service");
      }
    })
    .catch(e => {
      error('An Error Occurred')
    })
  },
  getServiceFields: function(success,error,maintenance){
    let self = this;
    this.api
    .getServiceFields(this.state.serviceId)
    .then(function (res) {
      if (res.data) {
        let data = res.data
        if (data.error) {
          error(data.error)
        } else {
            if(data.maintenanceMode){
              maintenance()
              return
            }
            self.state.fields = data.fields
            self.state.fields.forEach(field => {
              if(field.searchable == 1){
                field.searchValue = '';
                field.searchValues = [];
              }

              if(field.type == 'Select Dropdown' || field.type == 'Multi Select Dropdown'){
                field.selectOptionsArr = field.selectOptions.split(',');
              }
            });

            if(data.state) {
              self.state.stateSearchForm.value = data.state
            }
            success(self.state.fields)
        }
      }else{
          // error("Failed to get listings");
      }
    })
    .catch(e => {
      error('An Error Occurred')
    })
  },
  getService: function(success,error,maintenance){
    let self = this;
    this.api
    .getService(this.state.serviceId)
    .then(function (res) {
      if (res.data) {
        let data = res.data
        if (data.error) {
          error(data.error)
        } else {
            if(data.maintenanceMode){
              maintenance()
              return
            }
            self.state.service = data.service
            success(self.state.service)
        }
      }else{
          // error("Failed to get listings");
      }
    })
    .catch(e => {
      error('An Error Occurred')
    })
  },
  favorite: function(listing,success,error){
    let self = this;
    this.api
    .favorite(listing,this.state.currentUserId)
    .then(function (res) {
      if (res.data) {
        let data = res.data
        if (data.error) {
          error(data.error)
        } else {
            success(res.data)
        }
      }else{
          // error("Failed to get listings");
      }
    })
    .catch(e => {
      error('An Error Occurred')
    })
  },
  unfavorite: function(listing,success,error){
    let self = this;
    this.api
    .unfavorite(listing,this.state.currentUserId)
    .then(function (res) {
      if (res.data) {
        let data = res.data
        if (data.error) {
          error(data.error)
        } else {
            success(res.data)
        }
      }else{
          // error("Failed to get listings");
      }
    })
    .catch(e => {
      error('An Error Occurred')
    })
  },
  search: function() {
    var form = [];
    this.state.fields.forEach(it => {
      if (it.searchable == 1) {
        if (it.searchValue != "") {
          form.push({
            name: it.name,
            value: it.searchValue,
            type: "text"
          });
        }
      
        if (it.searchValues.length > 0) {
          form.push({
            name: it.name,
            value: it.searchValues,
            type: "Multi Select Dropdown"
          });
        }

        if (it.searchValue_startDate && it.searchValue_endDate) {
          form.push({
            name: it.name,
            startDate: it.searchValue_startDate,
            endDate: it.searchValue_endDate,
            type: "date"
          });
        }else if (it.searchValue_startDate) {
          form.push({
            name: it.name,
            startDate: it.searchValue_startDate,
            type: "date"
          });
        }else if (it.searchValue_endDate) {
          form.push({
            name: it.name,
            endDate: it.searchValue_endDate,
            type: "date"
          });
        }
      }
    });
    
    if(this.state.stateSearchForm.value != ''){
      form.push(this.state.stateSearchForm);
    }

    this.state.searchForm = form;
    var keptListings = [];
    this.state.listings.forEach(listing => {


      var keep = true;
      form.forEach(item => {

        let searchItem = this.getFormItem(form,item.name);
        let searchValue = searchItem.value;
        let searchType = searchItem.type;

        if(searchItem.name == 'state' && searchValue != ''){
          if(searchItem.value != ''){
            var contains = false;
            let cityStates = listing.cityStates;
            cityStates.forEach(cityState => {
              if(cityState.state == searchValue){
                contains = true;
              }
            });
            if(!contains){
              keep = false;
            }
          }
        }else{
          let value = this.getFieldValue(listing.fields,item.name);
          if(searchType == 'date'){

            if(searchItem.startDate && searchItem.endDate){
              let between = this.dateBetween(value,searchItem.startDate,searchItem.endDate);
              if(!between){
                keep = false;
              }
            }else if(searchItem.startDate){
              let add = this.dateAfter(value,searchItem.startDate);
              if(!add){
                keep = false;
              }
            }else if(searchItem.endDate){
              let add = this.dateAfter(value,searchItem.endDate);
              if(!add){
                keep = false;
              }
            }

            
          }else if(searchType == 'Multi Select Dropdown'){
            let contains = value.includes(searchValue);
            if(!contains){
              keep = false;
            }
          }else{
            
            let contains = this.contains(value,searchValue);
            if(!contains){
              keep = false;
            }
          }
        }
      });

      if(keep){
        keptListings.push(listing);
      }
    });

    this.state.filteredListings = keptListings;
    this.state.filterListings = true;
  },
  getFieldValue: function(fields,name) {

    let field = fields.find(it => {
      return it.name == name;
    })

    if(field){
      return field.value
    }

    return '';
  },
  getFormItem: function(fields,name) {
    return fields.find(it => {
      return it.name == name;
    });
  },
  contains: function(v1,v2){
    if(!v1 || !v2) {
      return false;
    }
    return v1.toLowerCase().includes(v2.toLowerCase());
  },
  dateBetween(date,start,end){
    let startMoment = moment(start);
    let endMoment = moment(end);
    let searchDateMoment = moment(date);
    return searchDateMoment >= startMoment && searchDateMoment <= endMoment;
  },
  dateAfter(date,start){
    let startMoment = moment(start);
    let searchDateMoment = moment(date);
    return searchDateMoment >= startMoment;
  },
  dateBefore(date,end){
    let endMoment = moment(end);
    let searchDateMoment = moment(date);
    return searchDateMoment <= endMoment;
  },
  sortBy(field) {
    if (field.name != this.state.sortedField.name) {
      this.state.sortedDirection = "DESC";
    }
    this.state.sortedField = field;

    if (this.state.sortedDirection == "ASC") {
      this.state.sortedDirection = "DESC";
    } else {
      this.state.sortedDirection = "ASC";
    }

    if(this.state.filterListings) {
      this.state.filteredListings = this.state.filteredListings.sort((a, b) => {
        let aIndex = a.fields.findIndex(it => {
          return it.name == field.name;
        });
  
        let bIndex = b.fields.findIndex(it => {
          return it.name == field.name;
        });
        if (this.state.sortedDirection == "ASC") {
          if(field.type == 'Date') {
            return this.sortDateAsc(moment(a.fields[aIndex].value ), moment(b.fields[bIndex].value), aIndex, bIndex);
          }
          return this.sortAsc(a, b, aIndex, bIndex);
        } else {
          if(field.type == 'Date') {
            return this.sortDateDesc(moment(a.fields[aIndex].value ), moment(b.fields[bIndex].value), aIndex, bIndex);
          }
          return this.sortDesc(a, b, aIndex, bIndex);
        }
      });
    } else {
      this.state.listings = this.state.listings.sort((a, b) => {
        let aIndex = a.fields.findIndex(it => {
          return it.name == field.name;
        });
  
        let bIndex = b.fields.findIndex(it => {
          return it.name == field.name;
        });
        if (this.state.sortedDirection == "ASC") {
          if(field.type == 'Date') {
            return this.sortDateAsc(moment(a.fields[aIndex].value ), moment(b.fields[bIndex].value), aIndex, bIndex);
          }
          return this.sortAsc(a, b, aIndex, bIndex);
        } else {
          if(field.type == 'Date') {
            return this.sortDateDesc(moment(a.fields[aIndex].value ), moment(b.fields[bIndex].value), aIndex, bIndex);
          }
          return this.sortDesc(a, b, aIndex, bIndex);
        }
      });
    }


  },
  sortAsc(a, b, aIndex, bIndex) {
    if (a.fields[aIndex].value < b.fields[bIndex].value) {
      return -1;
    }

    if (a.fields[aIndex].value < b.fields[bIndex].value) {
      return 1;
    }

    return 0;
  },
  sortDesc(a, b, aIndex, bIndex) {
    if (a.fields[aIndex].value > b.fields[bIndex].value) {
      return -1;
    }

    if (a.fields[aIndex].value > b.fields[bIndex].value) {
      return 1;
    }

    return 0;
  },
  sortDateAsc(a, b, aIndex, bIndex) {
    if (a < b) {
      return -1;
    }

    if (a < b) {
      return 1;
    }

    return 0;
  },
  sortDateDesc(a, b, aIndex, bIndex) {
    if (a > b) {
      return -1;
    }

    if (a > b) {
      return 1;
    }

    return 0;
  },
}

export default FeedStore



// WEBPACK FOOTER //
// ./src/components/FeedStore.js